import React, { useContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

const PopupContext = React.createContext(null);

export const usePopupContext = () => useContext(PopupContext);

export const usePopup = () => {
    const { popup, setPopup: setPopupState } = usePopupContext();

    const setPopup = useCallback(
        (name) => {
            const popupCookie = Cookies.get(`popup_${name}`) || null;
            setPopupState(popupCookie !== null ? null : name);
        },
        [setPopupState],
    );

    const closePopup = useCallback(
        (name) => {
            Cookies.set(`popup_${name}`, false);
            setPopupState(null);
        },
        [setPopupState],
    );

    const setPopupWithoutCookie = useCallback(
        (name) => {
            setPopupState(name || null);
        },
        [setPopupState],
    );

    const closePopupWithoutCookie = useCallback(() => {
        setPopupState(null);
    }, [setPopupState]);

    return {
        setPopup,
        closePopup,
        closePopupWithoutCookie,
        setPopupWithoutCookie,
        popup,
    };
};

const propTypes = {
    popup: PropTypes.bool,
    children: PropTypes.node.isRequired,
};

const defaultProps = {
    popup: null,
};

export const PopupProvider = ({ popup: initialPopup, children }) => {
    const popupCookie = Cookies.get(`popup_${initialPopup}`) || null;
    const [popup, setPopup] = useState(popupCookie !== null ? false : initialPopup);

    return <PopupContext.Provider value={{ popup, setPopup }}>{children}</PopupContext.Provider>;
};

PopupProvider.propTypes = propTypes;
PopupProvider.defaultProps = defaultProps;

export default PopupContext;
